import { useState } from "react";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";
import { scrollToSelectedSection } from "@util/utils.js";
const SubNav = ({ data, handleTabChange, tab, handleSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const handleOnClick = (e) => {
    e.preventDefault();
    handleTabChange(e.target.textContent.toLowerCase());
    scrollToSelectedSection(600);
  };
  return (
    <nav className="animated-sub-nav bg-white container has-form has-mobile-scroll pos-rel w-auto lg:-mt-10">
      <div className="mobile-scroll md:fx--o-2 md:pt-2.5 md:pb-2.5">
        <ul className="nav-categories" id="myBtnContainer">
          {data.navList.map((nav, index) => (
            <li className="text-xs text-lg-grey pb-3" key={index}>
              <a
                id={nav.id}
                href=""
                onClick={(e) => handleOnClick(e)}
                className={`lg:px-4 md:px-4 getItem ${
                  nav.name.toLowerCase() === tab ? "active" : ""
                } btn`}
              >
                {nav.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <form
        className="nav-form md:m-0 md:fx--o-1"
        id="search-container"
        onSubmit={(e) => {
          e.preventDefault();
        }}
        autoComplete="off"
      >
        <input
          type="text"
          placeholder={data.form.placeHolder}
          name="search-field"
          className="search-field"
          id="search-field"
          value={searchTerm}
          onInput={(e) => {
            setSearchTerm(e.target.value);
            if (e.target.value.length === 0) {
              handleSearch("");
            }
          }}
          onFocus={(e) => {
            e.target.parentElement.classList.add("focus");
          }}
          onBlur={(e) => {
            e.target.parentElement.classList.remove("focus");
          }}
        />
        <button
          className={`clear-search-btn ${searchTerm.length > 0 ? "show" : ""}`}
          type="button"
          aria-label="clear search"
          onClick={() => {
            setSearchTerm("");
            handleSearch("");
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <g fill="none" fill-rule="evenodd">
              <g className="svg-color" fill="#8495B1">
                <g>
                  <g>
                    <g>
                      <g>
                        <path
                          d="M10.53.137c.164.164.18.42.05.602l-.05.057-4.537 4.537L10.53 9.87c.182.183.182.478 0 .66-.164.164-.42.18-.602.05l-.058-.05-4.537-4.537L.796 10.53c-.182.182-.477.182-.66 0-.163-.164-.18-.42-.049-.602l.05-.058 4.536-4.537L.137.796C-.046.614-.046.32.137.136.3-.026.557-.043.739.088l.057.05 4.537 4.536L9.87.137c.183-.183.478-.183.66 0z"
                          transform="translate(-1245 -1918) translate(1040 1908) translate(205 10) translate(2 2) translate(.667 .667)"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </button>
        <button
          className="search-btn"
          type="submit"
          aria-label="search page"
          onClick={(e) => {
            if (searchTerm.length !== 0) {
              handleSearch(searchTerm);
            }
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
          >
            <g fill="none" fill-rule="evenodd">
              <g className="svg-color" fill="#8495B1">
                <g>
                  <g>
                    <g>
                      <g>
                        <path
                          d="M4.249.992c3.128-1.33 6.742.129 8.071 3.257.93 2.188.496 4.614-.92 6.33l3.93 3.93c.227.227.227.594 0 .821-.204.205-.523.225-.75.062l-.072-.062-3.93-3.93c-.447.37-.954.682-1.515.92-3.128 1.33-6.742-.129-8.071-3.257-1.33-3.128.129-6.742 3.257-8.071zm7.001 3.711C10.172 2.166 7.24.983 4.703 2.062 2.166 3.14.983 6.072 2.062 8.608c1.078 2.538 4.01 3.72 6.546 2.642.605-.257 1.133-.619 1.571-1.055l.007-.01.01-.007c1.389-1.398 1.873-3.55 1.054-5.475z"
                          transform="translate(-1252 -1622) translate(140 1592) translate(800 22) translate(312 8) translate(2 2)"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </button>
      </form>
      <style jsx>
        {`
          .animated-sub-nav {
            padding-bottom: 0px !important;
          }
          .animated-sub-nav li {
            margin-left: 0px !important;
            margin-right: 20px;
          }
          @media (max-width: ${viewport.tablet.sm}) {
          .animated-sub-nav {
            margin: 0;
            padding: 20px;
            background-color: #edf0f2;
          }
          .animated-sub-nav .nav-categories > li a.active {
            background-color: #fff;
          }
        `}
      </style>
    </nav>
  );
};

export default SubNav;
